import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { PessoasJuridicasPesquisaComponent } from "./pesquisa/pessoas-juridicas-pesquisa.component";

const routes: Routes = [
  {
    path: 'pessoas-juridicas/listagem',
    component: PessoasJuridicasPesquisaComponent,
    canActivate: [AuthenticationGuard],
    data: { canReuse: false }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class PessoasJuridicasRoutingModule { }
